import type { CartOutputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CART_ACTIVE_FILTER } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";

export const addEmailMutationKey = ["addEmail"] as const;

interface AddEmailInput {
  email: string;
}

export function useAddEmailMutation() {
  const cartClient = useServicesStore(state => state.cartClient);
  const cartId = useGlobalStore(state => state.cartId);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: addEmailMutationKey,
    mutationFn: async ({ email }: AddEmailInput): Promise<CartOutputDto> => {
      if (!cartClient) throw new Error("Cart client is not available.");
      if (!cartId) throw new Error("Cart id is not available.");
      return await cartClient.updateCustomerDetails(cartId, { email });
    },
    onSuccess: cart => {
      queryClient.setQueriesData<CartOutputDto | null>(CART_ACTIVE_FILTER, cart);
    },
  });
}
